import firstDayOnWeek from './first-day-on-week';

export default function getThisSaturday(date) {
    const lastDayOnWeek = firstDayOnWeek(date) + 6;
    const thisSaturday = new Date(date.getFullYear(), date.getMonth(), lastDayOnWeek);
    return thisSaturday;
}
